__turbopack_context__.v({
  "button": "ViewDetailsButton-module-scss-module__bS67aG__button",
  "container": "ViewDetailsButton-module-scss-module__bS67aG__container",
});
